import React, { useState } from "react";
import analytics from "web/script/analytics/analytics";
import classnames from "classnames";
import TrackedButton from "web/react/components/tracked-button/tracked-button";
import { gettext } from "web/script/modules/django-i18n";
// eslint-disable-next-line css-modules/no-unused-class
import styles from "./brand-ad-container.css";

interface BrandAdContainerProps {
    bannerImage: string;
    brandLogo: string;
    brandName: string;
    link: string;
    mpuImage: string;
}

function BrandAdContainer({
    bannerImage,
    brandLogo,
    brandName,
    link,
    mpuImage,
}: BrandAdContainerProps): null | JSX.Element {
    const [isActive, setIsActive] = useState(false);

    function toggleInfo(): void {
        analytics.event("brand_ads", "click", "perf_brand_ad_icon");
        setIsActive(!isActive);
    }

    return (
        <div className={styles.container}>
            <div className={styles.brandLogo}>
                <img src={brandLogo} alt={brandName} />
            </div>
            <TrackedButton
                href={link}
                eventCategory="brand_ads"
                eventAction="click"
                eventLabel="perf_brand_ad_banner"
            >
                <picture>
                    <source media="(max-width: 599px)" srcSet={mpuImage} />
                    <source media="(min-width: 600px)" srcSet={bannerImage} />
                    <img src={bannerImage} alt="test banner" />
                </picture>
            </TrackedButton>
            <button
                className={classnames(styles.info, {
                    [styles.active]: isActive,
                })}
                onClick={toggleInfo}
            >
                <span className={styles.infoIcon}>{"i"}</span>
                <span className={styles.infoLabel}>{gettext("feed.header.sponsored_label")}</span>
            </button>
        </div>
    );
}

export default BrandAdContainer;
